import { render, staticRenderFns } from "./AssessorFireTaxXRef.vue?vue&type=template&id=59a5b31d&"
import script from "./AssessorFireTaxXRef.vue?vue&type=script&lang=js&"
export * from "./AssessorFireTaxXRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports